export default __webpack_public_path__ + "static/media/WindowsTaskScheduler-Action04.3b6d19c3.png";